// extracted by mini-css-extract-plugin
export default {"spacing20":"SubmitSuccessful_spacing20__w-cKK","submitSuccessfulBullet":"SubmitSuccessful_submitSuccessfulBullet__hK47n"};